export default __webpack_public_path__ + "static/media/take_one.65c87cef.jpg";